import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporter({customer_id, agro_exporter_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_inspects/agro_exporter/${customer_id}/${agro_exporter_id}`
    );
  },
  fetchContainer({customer_id, agro_exporter_id, container_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_inspects/container/${customer_id}/${agro_exporter_id}/${container_id}`
    );
  },
  fetchTemplate({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_inspects/quality_template/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}`
    );
  },
  fetchInspects({customer_id, agro_exporter_id, container_id, exporter_process_quality_template_id}) {
    return RequesterV1.get(
      `customer/quality_control/destination/list_inspects/${customer_id}/${agro_exporter_id}/${container_id}/${exporter_process_quality_template_id}`
    );
  },
};
